import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const ContactUs = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("ContactUs", "contact/contact_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.ContactUs || { Main: {} };
  // 建立 state 來暫存表單輸入
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    phone: '',
  });

  // 監聽表單欄位變化
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // 攔截表單提交
  const handleSubmit = async (e) => {
    e.preventDefault(); // 阻止瀏覽器跳轉（預設行為）

    // 從 state 取出資料
    const { name, email, subject, message, phone } = formData;

    // 準備要送到後端的資料
    const data = {
      subject,         // 後端需要的欄位
      message,
      email,
      name,
      phone,
      language,
    };

    try {
      // 使用 fetch 向後端 /send-email 發送 POST 請求
      const response = await fetch('/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data), // 將物件轉成 JSON
      });

      const result = await response.json();

      if (response.ok) {
        // response.ok 表示狀態碼 200~299
        alert(result.success || 'Thank you for contacting us. We will get back to you as soon as possible.！');
      } else {
        // response 非 2xx，表示有錯
        alert(result.error || 'An error occurred. Please try again later!');
      }
    } catch (error) {
      console.error('發生錯誤:', error);
      alert('An error occurred. Please try again later!');
    }
  };
  return (
    <div
      className="container-fluid py-5 wow fadeInUp"
      data-wow-delay="0.1s"
      style={{ visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeInUp' }}
      id="contact"
    >
      <div className="container py-5">
        <div
          className="section-title text-center position-relative pb-3 mb-5 mx-auto"
          style={{ maxWidth: '600px' }}
        >
          <h5 className="fw-bold text-primary text-uppercase">{LANGUAGE.Main.Content1}</h5>
          <h1 className="mb-0">{LANGUAGE.Main.Content2}</h1>
        </div>
        <div className="row g-5 mb-5">
          {/* <div className="col-lg-4">
            <div
              className="d-flex align-items-center wow fadeIn"
              data-wow-delay="0.1s"
              style={{ visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeIn' }}
            >
              <div
                className="bg-primary d-flex align-items-center justify-content-center rounded"
                style={{ width: '60px', height: '60px' }}
              >
                <a href={`tel:${LANGUAGE.Main.Content4}`}><i className="fa fa-phone-alt text-white"></i></a>
              </div>
              <div className="ps-4">
                <h5 className="mb-2">{LANGUAGE.Main.Content3}</h5>
                <a href={`tel:${LANGUAGE.Main.Content4}`}><h4 className="text-primary mb-0">{LANGUAGE.Main.Content4}</h4></a>
              </div>
            </div>
          </div> */}
          <div className="col-lg-6">
            <div
              className="d-flex align-items-center wow fadeIn"
              data-wow-delay="0.4s"
              style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeIn' }}
            >
              <div
                className="bg-primary d-flex align-items-center justify-content-center rounded"
                style={{ width: '60px', height: '60px' }}
              >
                <i className="fa fa-envelope-open text-white"></i>
              </div>
              <div className="ps-4">
                <h5 className="mb-2">{LANGUAGE.Main.Content5}</h5>
                <h4 className="text-primary mb-0">{LANGUAGE.Main.Content6}</h4>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="d-flex align-items-center wow fadeIn"
              data-wow-delay="0.8s"
              style={{ visibility: 'visible', animationDelay: '0.8s', animationName: 'fadeIn' }}
            >
              <div
                className="bg-primary d-flex align-items-center justify-content-center rounded"
                style={{ width: '60px', height: '60px' }}
              >
                <i className="fa fa-map-marker-alt text-white"></i>
              </div>
              <div className="ps-4">
                <h5 className="mb-2">{LANGUAGE.Main.Content7}</h5>
                <h4 className="text-primary mb-0">{LANGUAGE.Main.Content8}</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-5">
          <div
            className="col-lg-6 wow slideInUp"
            data-wow-delay="0.3s"
            style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'slideInUp' }}
          >
            {/* <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control border-0 bg-light px-4"
                    placeholder={LANGUAGE.Main.Content9}
                    name="name"
                    style={{ height: '55px' }}
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="phone"
                    className="form-control border-0 bg-light px-4"
                    placeholder={LANGUAGE.Main.Content14}
                    name="phone"
                    style={{ height: '55px' }}
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-12">
                  <input
                    type="email"
                    className="form-control border-0 bg-light px-4"
                    placeholder={LANGUAGE.Main.Content10}
                    name="email"
                    style={{ height: '55px' }}
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    className="form-control border-0 bg-light px-4"
                    placeholder={LANGUAGE.Main.Content11}
                    name="subject"
                    style={{ height: '55px' }}
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-12">
                  <textarea
                    className="form-control border-0 bg-light px-4 py-3"
                    rows="4"
                    placeholder={LANGUAGE.Main.Content12}
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>
                <div className="col-12">
                  <button className="btn btn-primary w-100 py-3" type="submit">
                    {LANGUAGE.Main.Content13}
                  </button>
                </div>
              </div>
            </form> */}
          </div>
          <div
            className="col-lg-6 wow slideInUp"
            data-wow-delay="0.6s"
            style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'slideInUp' }}
          >
            <iframe
              className="position-relative rounded w-100 h-100"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.2987096799116!2d120.29545788537129!3d22.605317978847065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e033d9a2af75d%3A0x671d44309c4e789a!2z5Lqe54Gj5paw5Ym15ZySIFN0YXJ0dXAgVGVycmFjZSBLYW9oc2l1bmc!5e0!3m2!1szh-TW!2stw!4v1727251548405!5m2!1szh-TW!2stw"
              frameBorder="0"
              style={{ minHeight: '350px', border: 0 }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;